var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":"Planos"}}),(_vm.loading_data)?_c('Loading'):_c('HandleDisplayPlans',{attrs:{"plans":_vm.PlanList,"kept":_vm.EditList},on:{"update:kept":_vm.updateKept}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }